/* RovaHair — centred product carousel (rv-product-slider-2) */
(function () {
  'use strict';
  var GLIDE_SRC = 'https://cdn.jsdelivr.net/npm/@glidejs/glide@3.6.1/dist/glide.min.js';

  // Load Glide once for every rv-* slider on the page (same helper as rv-ba-slider.js).
  if (!window.rvLoadGlide) {
    window.rvLoadGlide = function (done) {
      if (window.Glide) { done(); return; }
      var q = (window.rvLoadGlide.queue = window.rvLoadGlide.queue || []);
      q.push(done);
      if (q.length > 1) return;
      var s = document.querySelector('script[src="' + GLIDE_SRC + '"]');
      if (!s) {
        s = document.createElement('script');
        s.src = GLIDE_SRC;
        s.defer = true;
        document.head.appendChild(s);
      }
      var flush = function () {
        if (!window.Glide) return;
        var list = window.rvLoadGlide.queue.splice(0);
        list.forEach(function (fn) { try { fn(); } catch (e) {} });
      };
      s.addEventListener('load', flush);
      var tries = 0;
      (function poll() { if (window.Glide) { flush(); } else if (tries++ < 100) { setTimeout(poll, 100); } })();
    };
  }

  if (window.rvProductSlider2) return;

  function num(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }

  function Slider(root) {
    this.root = root;
    this.glideEl = root.querySelector('.rv-ps-glide');
    this.mode = root.getAttribute('data-video-mode') || 'all'; // off | all | active
    this.lb = document.getElementById(root.id + '-lb');
    this.onClick = this.onClick.bind(this);
    this.onKey = this.onKey.bind(this);
  }

  Slider.prototype.mount = function () {
    var g = this.glideEl;
    if (!g) return;
    var slides = g.querySelectorAll('.glide__slide');
    this.count = slides.length;
    if (!this.count) return;
    slides.forEach(function (el, i) { el.setAttribute('data-slide-index', i); });

    var perView = num(g.getAttribute('data-per-view'), 5);
    var autoplay = g.getAttribute('data-autoplay') === 'true' ? num(g.getAttribute('data-autoplay-speed'), 4000) : false;
    var self = this;

    try {
      this.glide = new window.Glide(g, {
        type: 'carousel',
        focusAt: 'center',
        perView: perView,
        startAt: Math.floor(this.count / 2),
        gap: num(g.getAttribute('data-gap'), 16),
        animationDuration: Math.max(200, num(this.root.getAttribute('data-animation-ms'), 500)),
        dragThreshold: 100,
        swipeThreshold: 100,
        peek: { before: 40, after: 40 },
        rewind: true,
        autoplay: autoplay,
        breakpoints: {
          1600: { perView: perView },
          1400: { perView: Math.max(1, perView - 1) },
          1200: { perView: 3 },
          1000: { perView: 2, peek: { before: 30, after: 30 } },
          600: { perView: 1.5, peek: { before: 30, after: 30 } }
        }
      });
      this.glide.on('run.after', function () { self.syncVideos(); });
      this.glide.mount();
    } catch (e) {
      this.glide = null;
      return;
    }

    g.addEventListener('click', this.onClick);
    if (this.lb) {
      this.lb.querySelector('.rv-ps-lb-bg').addEventListener('click', this.closeLb.bind(this));
      this.lb.querySelector('.rv-ps-lb-x').addEventListener('click', this.closeLb.bind(this));
      document.addEventListener('keydown', this.onKey);
    }
    this.syncVideos();
  };

  Slider.prototype.index = function (i) { return ((i % this.count) + this.count) % this.count; };

  Slider.prototype.syncVideos = function () {
    if (!this.glide) return;
    var mode = this.mode;
    var active = this.index(this.glide.index);
    this.glideEl.querySelectorAll('video.rv-ps-video').forEach(function (v) {
      v.muted = true;
      v.loop = true;
      var slide = v.closest('.glide__slide');
      var isActive = slide && slide.classList.contains('glide__slide--active') &&
        num(slide.getAttribute('data-slide-index'), -1) === active;
      var play = mode === 'all' || (mode === 'active' && isActive);
      try {
        if (play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!isActive || mode === 'off') { v.pause(); }
      } catch (e) {}
    });
  };

  Slider.prototype.onClick = function (e) {
    var play = e.target.closest('[data-rv-ps-play]');
    if (play) {
      e.preventDefault();
      var src = play.closest('.rv-ps-media').querySelector('video');
      if (src) this.openLb(src);
      return;
    }
    var slide = e.target.closest('.glide__slide[data-slide-index]');
    if (!slide || !this.glide) return;
    var i = num(slide.getAttribute('data-slide-index'), -1);
    if (i >= 0 && i !== this.index(this.glide.index)) this.glide.go('=' + i);
  };

  Slider.prototype.openLb = function (src) {
    if (!this.lb) return;
    var v = this.lb.querySelector('video');
    v.innerHTML = src.innerHTML;
    v.load();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    this.lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  Slider.prototype.closeLb = function () {
    if (!this.lb || !this.lb.classList.contains('is-open')) return;
    var v = this.lb.querySelector('video');
    v.pause();
    v.innerHTML = '';
    this.lb.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  Slider.prototype.onKey = function (e) { if (e.key === 'Escape') this.closeLb(); };

  Slider.prototype.destroy = function () {
    if (this.glideEl) this.glideEl.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKey);
    this.closeLb();
    if (this.glide) { try { this.glide.destroy(); } catch (e) {} this.glide = null; }
  };

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-rv-ps]');
    if (!list.length) return;
    window.rvLoadGlide(function () {
      list.forEach(function (root) {
        if (root.rvSlider) return;
        root.rvSlider = new Slider(root);
        root.rvSlider.mount();
      });
    });
  }

  window.rvProductSlider2 = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rv-ps]').forEach(function (root) {
      if (root.rvSlider) { root.rvSlider.destroy(); root.rvSlider = null; }
    });
  });
})();
